import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"]

  connect() {
    this.submitting = false
    // Keep the bound handlers so disconnect() removes the same functions it added.
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this)
    this.textareaTarget.addEventListener("keydown", this.boundHandleKeydown)
    this.element.addEventListener("turbo:submit-end", this.boundHandleSubmitEnd)
  }

  disconnect() {
    this.textareaTarget.removeEventListener("keydown", this.boundHandleKeydown)
    this.element.removeEventListener("turbo:submit-end", this.boundHandleSubmitEnd)
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      if (this.textareaTarget.value.trim() === "" || this.submitting) return
      this.submitting = true
      this.element.requestSubmit()
    }
  }

  handleSubmitEnd(event) {
    this.submitting = false // Always reset submitting flag
    if (event.detail.success) {
      this.textareaTarget.value = ""
      this.textareaTarget.focus()
    }
  }
}
